import { render, staticRenderFns } from "./selectRestrictions.vue?vue&type=template&id=ee7f0504&"
import script from "./selectRestrictions.vue?vue&type=script&lang=js&"
export * from "./selectRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports